module.exports = __webpack_public_path__ + "img/rf.07b55c36.jpg";